import React from 'react'

import { Link } from "react-router-dom";

import './NotFoundPage.scss';

function NotFoundPage() {
  return (
    <div className="container block landing-text-background honey-round-border is-max-desktop">
      <section className="hero">
        <div className="hero-body">
          <h1 className="has-text-weight-bold is-size-1 honey-text-font-family-common honey-text-common">
            Not Found
          </h1>
          <div className="honey-not-found-spacer"></div>
          <div className="block">
            <Link to="/">
              <button className="button honey-not-found-button">Back Home</button>
            </Link>
          </div>
          <div className="block">
            <Link to="/api">
              <button className="button honey-not-found-button">Discover the API</button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default NotFoundPage;
